import { Link, useLocation } from "react-router-dom";
import { formatDate } from "../../utils/methods";
import { Card, CardHeader, CardImage, CardContent, CardDate, CardTitle, CardDescription } from "./styles";

export default function BlogCard({ content }) {
  const rawDescription = content.description || "";
  const location = useLocation();

  const to = `/blog/${content.slug}`;
  const isCurrent = location.pathname === to;

  const cardContent = (
    <Card highlight={content.highlight} height={content.height} isCurrent={isCurrent}>
      <CardHeader>
        <CardImage src={content.imageUrl} alt={content.title} />
      </CardHeader>
      <CardContent>
        <CardDate>{formatDate(content.createdAt)}</CardDate>
        <CardTitle height={content.height}>{content.title}</CardTitle>
        <CardDescription
          height={content.height}
          isCurrent={isCurrent}
          dangerouslySetInnerHTML={{ __html: rawDescription }}
        />
      </CardContent>
    </Card>
  );

  return isCurrent ? cardContent : (
    <Link to={to} state={{ content }}>
      {cardContent}
    </Link>
  );
}